import { useFormContext } from 'react-hook-form';
import { FormSwitch } from 'redesign';
import { getRequiredMessage } from './shared';
import { IsFreelanceOrtApplicableContext, Props } from './is-ort-applicable.types';

export const IsFreelanceOrtApplicableSwitch = (props: Props) => {
  const { control } = useFormContext<IsFreelanceOrtApplicableContext>();
  const label = 'ORT toegepast';
  const requiredMessage = getRequiredMessage(label);
  const name = 'isFreelanceOrtApplicable';

  return (
    <FormSwitch
      name={name}
      control={control}
      label={label}
      disabled={props.disabled}
      rules={props.required ? { required: requiredMessage } : undefined}
    />
  );
};
